<template>
  <li class="catalog-item">
    <div class="item-holder" :class="{ 'not-available': !item.stock }" v-if="categoryObject?.info?.url">
      <div class="product-label label-new" v-if="isHot(item)">
        <span class="label-text">New</span>
      </div>
      <div class="product-label label-sale" v-if="item.price_old && getDiscount(item) > 0">
        <div class="tile_label tile_sale">-{{ getDiscount(item) }}%</div>
      </div>
      <router-link
        :to="{ name: 'ItemOrServiceItem', params: { category: categoryObject.info.url, id: item.id }, query: $route.query }"
        class="image bg-cover" :style="{ 'background-image': $filters.getItemImage(item.preview) }"
        exact-path></router-link>
      <div class="product-name">
        <router-link
          :to="{ name: 'ItemOrServiceItem', params: { category: categoryObject.info.url, id: item.id }, query: $route.query }"
          exact-path>
          {{ $dynamic(item, item.title, 'title') }}
        </router-link>
      </div>
      <div class="particular" v-if="ingredient.length > 0">
        <div class="custom-label">
          {{ $static('item.badge-title', 'Особливості') }}
        </div>
        <ul>
          <li v-for="(badge, badgeIndex) in ingredient" :key="badge + badgeIndex">
            <img v-if="badge.image" :src="badge.image" :alt="badge.name" class="label-pic">
            <span v-if="badge.color && !badge.image"
              :style="{ 'backgroundColor': badge.color, 'display': 'inline-block' }" class="label-pic"></span>
            <span class="text">{{ $dynamic(badge, badge.name, 'name') }}</span>
          </li>
        </ul>
      </div>

      <div class="options">
        <div class="price-box">
          <div class="price-element" v-if="item.price > 0" :class="{ 'was-selled': !!item.price_old }"> {{
            $filters.money(item.price) }}
            {{ settings.symbol }}
          </div>
          <div class="price-old" v-if="item.price_old"> {{ $filters.money(item.price_old) }}
            {{ settings.symbol }}
          </div>
        </div>
        <div class="right-options" v-if="categoryObject.info?.url">
          <router-link
            :to="{ name: 'ItemOrServiceItem', params: { category: categoryObject.info.url, id: item.id }, query: $route.query }"
            v-if="hasOptions || !item.stock" class="default-btn">
            <span class="btn-text">{{ $static('catalog.info', 'Детальніше') }}</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.5 10L12.8536 9.64645L13.2071 10L12.8536 10.3536L12.5 10ZM7.85355 4.64645L12.8536 9.64645L12.1464 10.3536L7.14645 5.35355L7.85355 4.64645ZM12.8536 10.3536L7.85355 15.3536L7.14645 14.6464L12.1464 9.64645L12.8536 10.3536Z"
                fill="white" />
            </svg>
          </router-link>
          <template v-else>
            <!-- <a href="javascript:void(0)" v-if="!isCatalogMod && productItemType !== 'ServiceItem'" @click="buy"  -->
            <button v-if="!isCatalogMod && !item.advanced.isService" @click="buy" class="default-btn">
              <span class="btn-text">{{ $static('catalog.buy', 'Замовити') }}</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.33301 11.0417C8.67819 11.0417 8.95801 11.3215 8.95801 11.6667V13.3333C8.95801 13.6785 8.67819 13.9583 8.33301 13.9583C7.98783 13.9583 7.70801 13.6785 7.70801 13.3333V11.6667C7.70801 11.3215 7.98783 11.0417 8.33301 11.0417Z"
                  fill="white" />
                <path
                  d="M12.2913 11.6667C12.2913 11.3215 12.0115 11.0417 11.6663 11.0417C11.3212 11.0417 11.0413 11.3215 11.0413 11.6667V13.3333C11.0413 13.6785 11.3212 13.9583 11.6663 13.9583C12.0115 13.9583 12.2913 13.6785 12.2913 13.3333V11.6667Z"
                  fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.04094 2.81248C8.21353 2.51355 8.11111 2.13131 7.81217 1.95872C7.51324 1.78613 7.131 1.88855 6.95841 2.18748L5.29174 5.07423C5.26677 5.11748 5.24756 5.16247 5.23386 5.20832H4.99967C3.73402 5.20832 2.70801 6.23433 2.70801 7.49998C2.70801 8.21592 3.03631 8.85518 3.55059 9.27543L4.10637 13.096L4.47865 14.8403C4.70171 15.8854 5.55487 16.6792 6.61331 16.8265C8.86006 17.1391 11.1393 17.1391 13.386 16.8265C14.4445 16.6792 15.2976 15.8854 15.5207 14.8403L15.893 13.096L16.4488 9.27543C16.963 8.85518 17.2913 8.21592 17.2913 7.49998C17.2913 6.23433 16.2653 5.20832 14.9997 5.20832H14.7655C14.7518 5.16247 14.7326 5.11748 14.7076 5.07423L13.0409 2.18748C12.8684 1.88855 12.4861 1.78613 12.1872 1.95872C11.8882 2.13131 11.7858 2.51355 11.9584 2.81248L13.3416 5.20832H6.6577L8.04094 2.81248ZM15.1109 9.789C15.074 9.79076 15.037 9.79165 14.9997 9.79165H4.99967C4.96239 9.79165 4.92531 9.79076 4.88845 9.789L5.33742 12.8753L5.70112 14.5794C5.81444 15.1103 6.24786 15.5136 6.78558 15.5884C8.91804 15.8851 11.0813 15.8851 13.2138 15.5884C13.7515 15.5136 14.1849 15.1103 14.2982 14.5794L14.6619 12.8753L15.1109 9.789ZM3.95801 7.49998C3.95801 6.92469 4.42438 6.45832 4.99967 6.45832H14.9997C15.575 6.45832 16.0413 6.92469 16.0413 7.49998C16.0413 8.07528 15.575 8.54165 14.9997 8.54165H4.99967C4.42438 8.54165 3.95801 8.07528 3.95801 7.49998Z"
                  fill="white" />
              </svg>
            </button>


            <button v-else class="default-btn" @click="$emit('leaveLead', this.item)">
              <span class="btn-text">{{ $static('item.leave-request', 'Залишити заявку') }}</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.82307 11.683C4.85955 11.6953 4.89637 11.704 4.93315 11.7094C4.97326 11.8036 5.02509 11.9256 5.08555 12.0682C5.23312 12.4162 5.43194 12.8869 5.63717 13.3779C6.05571 14.3793 6.47789 15.4116 6.57113 15.7071C6.68655 16.0724 6.80856 16.3207 6.94176 16.4902C7.01062 16.5779 7.09028 16.6545 7.18348 16.7124C7.2304 16.7416 7.27996 16.7655 7.33169 16.7834C7.33397 16.7841 7.33625 16.7849 7.33852 16.7857C7.6052 16.8864 7.84833 16.8444 8.00056 16.7931C8.08201 16.7657 8.14791 16.7325 8.19462 16.7057C8.21843 16.692 8.23855 16.6792 8.2546 16.6684L8.25839 16.6659L10.6136 15.1972L13.334 17.2828C13.3742 17.3136 13.418 17.3394 13.4643 17.3597C13.7912 17.5023 14.1076 17.552 14.4054 17.5113C14.7025 17.4708 14.9385 17.3459 15.1142 17.2054C15.2862 17.0677 15.4028 16.9136 15.4754 16.7991C15.5125 16.7406 15.5403 16.6889 15.56 16.6492C15.5698 16.6293 15.5778 16.6122 15.5839 16.5984L15.5918 16.5802L15.5947 16.5731L15.596 16.57L15.5965 16.5686L15.5971 16.5673C15.6113 16.5316 15.6223 16.4946 15.6298 16.4569L18.1133 3.9356C18.1213 3.89556 18.1253 3.85482 18.1253 3.81399C18.1253 3.44732 17.9871 3.09866 17.6622 2.88708C17.3846 2.70625 17.0753 2.69847 16.8798 2.7133C16.6689 2.72931 16.4742 2.78136 16.3435 2.82295C16.2755 2.8446 16.2184 2.86549 16.1773 2.88142C16.1567 2.88943 16.1397 2.89631 16.1271 2.90155L16.1176 2.90554L2.1895 8.36933L2.18769 8.36997C2.17882 8.3732 2.16742 8.37746 2.15388 8.38273C2.12691 8.39323 2.09077 8.40802 2.04856 8.42716C1.96624 8.46446 1.85076 8.52277 1.73225 8.60392C1.54293 8.73357 1.10752 9.08866 1.18084 9.67474C1.23933 10.1423 1.55965 10.4295 1.75481 10.5676C1.86196 10.6434 1.96377 10.6976 2.03791 10.7329C2.07231 10.7493 2.14372 10.7783 2.17471 10.7909L2.18253 10.7941L4.82307 11.683ZM16.6051 4.05654L16.6031 4.05738C16.5962 4.0604 16.5892 4.06329 16.5822 4.06605L2.63712 9.53647C2.62984 9.53933 2.62251 9.54204 2.61512 9.54462L2.60736 9.54756C2.59844 9.55103 2.58342 9.55714 2.56457 9.56568C2.55388 9.57053 2.54272 9.57581 2.53135 9.58149C2.54697 9.59029 2.56193 9.59793 2.57522 9.60426C2.58798 9.61033 2.59771 9.61449 2.60304 9.61667L5.22189 10.4983C5.26983 10.5145 5.31451 10.5359 5.35553 10.5616L14.0029 5.49954L14.011 5.49476C14.0173 5.49105 14.0255 5.48625 14.0355 5.48064C14.0551 5.46952 14.0822 5.45472 14.1143 5.43835C14.1744 5.4078 14.2704 5.36246 14.3785 5.32903C14.4539 5.30575 14.6759 5.24018 14.916 5.31718C15.0642 5.36471 15.2176 5.46687 15.3174 5.63996C15.3669 5.72595 15.3934 5.81233 15.4061 5.89141C15.4401 6.01598 15.4348 6.13899 15.4082 6.24519C15.3509 6.47394 15.1901 6.65238 15.0439 6.78886C14.9186 6.90587 13.2974 8.46908 11.6982 10.0122C10.9006 10.7818 10.1112 11.5437 9.52113 12.1133L9.13359 12.4874L14.0269 16.2389C14.1391 16.2791 14.2055 16.277 14.2362 16.2729C14.2727 16.2679 14.3027 16.2538 14.3332 16.2293C14.3674 16.202 14.3973 16.165 14.4197 16.1298L14.4206 16.1283L16.8293 3.98416C16.7936 3.99275 16.7574 4.00299 16.7226 4.01408C16.6831 4.02664 16.6506 4.03859 16.629 4.04695C16.6184 4.05109 16.6107 4.05424 16.6065 4.05597L16.6051 4.05654ZM9.55398 14.3848L8.57774 13.6363L8.34119 15.1411L9.55398 14.3848ZM7.68217 12.1512L8.65298 11.2139C9.24306 10.6443 10.0326 9.88231 10.8302 9.11269L11.6406 8.33081L6.20723 11.5115L6.23638 11.5802C6.38447 11.9295 6.58418 12.4023 6.7905 12.8959C6.94477 13.265 7.10609 13.6537 7.25303 14.0135L7.48889 12.5132C7.51163 12.3685 7.5823 12.2433 7.68217 12.1512Z"
                  fill="white" />
              </svg>
            </button>
          </template>
        </div>
      </div>
<!--      <div class="catalog-item-links">-->
<!--        <a v-if="link" :href="link">{{ $static('iconsbtn.catalog-item-link', 'Посилання') }}</a>-->
<!--        <a v-if="tgLink" :href="tgLink">{{ $static('iconsbtn.catalog-item-tg-link', 'Посилання UX') }}</a>-->
<!--        <a :href="shopLink">{{ $static('iconsbtn.catalog-item-shop-link', 'Посилання Телеграм') }}</a>-->
<!--      </div>-->
    </div>
  </li>
</template>

<script>
import { fixBodyPadding } from '@/utils/fixBodyPadding'

export default {
  name: 'CatalogItemPreview',
  props: ['item', 'categoryObject'],

  data() {
    return {
      order: {
        count: 1,
        selectedMod: 0,
        additionSelect: [],
        additionUSelect: []
      }
    }
  },

  computed: {
    settings() {
      return this.$store.getters.getSettings
    },
    link() {
      let host = location.host;
      return this.categoryObject?.info?.url ?
          `${location.protocol}//${host}/catalog/${this.categoryObject.info.url}/${this.item.id}`:
          undefined;
    },
    shopLink() {
      let host = location.host;
      return `${location.protocol}//${host}/shop/${this.item.id}`
    },
    tgLink() {
      let hex = parseInt(this.item.id, 10).toString(16)
      return this.settings?.DIRECT_LINK ? this.settings.DIRECT_LINK + `?startapp=t${hex}`: undefined;
    },
    basked() {
      return this.$store.state.busked
    },
    isCatalogMod() {
      return this.settings?.catalog_mod
    },
    ingredient() {
      return this.item?.advanced?.options?.ingredient ? this.item?.advanced?.options?.ingredient.map(id => (
        this.ingridients?.list?.find(x => x.id === id)
      ))?.filter(i => !!i)?.sort((a, b) => a.order - b.order) : []
    },
    ingridients() {
      return this.$store.getters.getOptions?.ingredient ? this.$store.getters.getOptions.ingredient : {}
    },
    options_list() {
      return this.$store.getters.getOptions
    },
    hasOptions() {
      if (this.item?.advanced?.uOption?.length || this.item?.group_id) {
        return true
      }
      // Проверка наличия необходимых объектов
      if (
        this.item &&
        this.item.advanced &&
        this.item.advanced.options &&
        this.options_list
      ) {
        // Получаем массив ключей из this.item.advanced.options
        const itemOptionsKeys = Object.keys(this.item.advanced.options);

        // Используем метод some для проверки условий
        const res = itemOptionsKeys.some(key => {
          // Исключаем ключ "ingredient"
          if (key === "ingredient") return false;

          // Проверяем, существует ли такой же ключ в this.options_list
          if (!Object.prototype.hasOwnProperty.call(this.options_list, key)) return false;


          // Получаем массивы из обоих объектов
          const itemOptionIds = this.item.advanced.options[key]; // [518, 519]
          const optionList = this.options_list[key].list; // [{id: 518, ...}, {id: 519, ...}, {id: 520, ...}]

          // Проверяем, что оба массива непустые
          if (!Array.isArray(itemOptionIds) || itemOptionIds.length === 0) return false;
          if (!Array.isArray(optionList) || optionList.length === 0) return false;

          // Извлекаем массив ID из optionList
          const optionListIds = optionList.map(item => item.id);

          // Проверяем наличие хотя бы одного совпадения ID
          const hasMatch = itemOptionIds.some(id => optionListIds.includes(id));

          // console.log(`Проверка для ключа "${key}":`, {
          //   itemOptionIds,
          //   optionListIds,
          //   hasMatch
          // });

          return hasMatch;
        });

        return res;
      }
      return false
    }
  },
  methods: {
    isHot(item) {
      return item.advanced && item.advanced.hot
    },
    getDiscount(item) {

      return item ? (1 - Math.max(item.price / item.price_old, 0)) * 100 | 0 : ''
    },
    buy() {
      let idx = -1;
      idx = this.basked.findIndex(i => i.id === this.item.id);
      if (idx > -1) {
        // this.basked[idx].count += this.order.count;
        this.$store.commit(
          'replaceBuskedIndex',
          { index: idx, value: JSON.parse(JSON.stringify(Object.assign({}, this.order, this.item))) }
        );
      } else {
        let item = JSON.parse(JSON.stringify(Object.assign({}, this.order, this.item)))
        this.$store.commit(
          'addToBasked',
          item
        );
        this.$AddToCart(item)
      }
      this.toggleBusked()

      // fixBodyPadding();
      // window.$('body').addClass('no-scroll');
      // window.$('#quick_cart').addClass('opened');
      // window.$('.frame-modal-wrapper-bg').addClass('is-visible');
    },
    toggleBusked() {
      fixBodyPadding();

      this.$store.commit('setBuskedOpen', !this.isBuskedOpen)

      this.$store.commit('setSearchOpen', false);
      this.$store.commit('setReadMoreOpen', false)

      window.$('.overlay-menu').removeClass('active');
      window.$('.open-nav').removeClass('is-visible');
      window.$('.show-menu-btn').removeClass('open');

      window.$('.personal-area-modal-wrapper-bg').removeClass('is-visible');
      window.$('.personal_area-sidebar').removeClass('opened');
      window.$('.login-trigger-item').removeClass('active');


      window.$('.cart-modal-wrapper-bg').toggleClass('is-visible');
      window.$('.quick-card-sticker-li').toggleClass('active');
      window.$('#quick_cart').toggleClass('opened');

      window.$('body').toggleClass('no-scroll');
      // window.$('.cart-modal-wrapper-bg').toggleClass('is-visible');
    }
  }
}
</script>

<style scoped>
.label-pic {
  display: inline-block;
  height: 11px;
  margin-right: 3px;
  vertical-align: middle;
  position: relative;
  top: -1px;
  width: 11px;
  margin-top: 0;
}

.catalog-item .not-available .options,
.catalog-item .not-available .product-name {
  opacity: 0.6;
}

.catalog-item .not-available .image {
  filter: grayscale(100%);
}
</style>